export default "/images/438557ff78954f17c093f0e75ed6dd2c.avif";